import React, { Component } from "react";
import { graphql, Link } from "gatsby";
import SEO from "../components/seo";
import Layout from "../components/layout";
import ServiceHero from "../components/service-hero";
import CTA from "../components/cta-bar";
import styled from "styled-components";
import Card from "../components/card";
import PhotoGalleryComponent from "../components/photo-gallery-component";
import SocialReviewsFullwidth from "../components/social-reviews-fullwidth";
import { TestimonialSection } from "../components/testimonial_video";
import { getSchemaSameAs } from "../helpers/schema-json";
import { intersperse } from "../helpers/react";
import { CheckCircle, MapPin } from "react-feather";
import FAQ from "../components/FAQ";
import RoofingCalculator from "../components/sidebars/roof-calc";
import WhyRoachStandsOut from "../components/why-roach-stands-out";
import RoofingServicesGrid from "../components/roofing-services-grid";
import GetANewRoofSteps from "../components/get-a-new-roof-steps";
import JacksonEmergencyAndCosts from "../components/jackson-emergency-and-costs";
import CityTrustStrip from "../components/city-trust-strip";
import CityHappyCustomers from "../components/city-happy-customers";
import CityTrustedChoice from "../components/city-trusted-choice";
import CityNeighborhoods from "../components/city-neighborhoods";
import CityContactCard from "../components/city-contact-card";
import WyomingCostsAndPermits from "../components/wyoming-costs-and-permits";
import CityCtaPair from "../components/city-cta-pair";
import CityEmergencyRepair from "../components/city-emergency-repair";
import CityBodyContent from "../components/city-body-content";
import siteConfig from "../siteConfig";
import cityPageContent from "../data/city-page-content";

const MainContentContainer = styled.div``;
const SidebarContainer = styled.div``;

const WhiteBGSection = styled.section`
  background: #f9f9f9;
  padding: 2.5em 1em;
  box-shadow: rgba(0, 0, 0, 0.03) 0px 2px 4px 0px;
`;
class ServiceCityTemplate extends Component {
  render() {
    function parseContent(string, altCity) {
      if (string) {
        const newString = string.replace(/{{city}}/g, altCity ? altCity : city);
        const secondReplacement = newString.replace(
          /{{citySlug}}/g,
          (altCity ? altCity : city).replace(/\./g, "").toLowerCase().replace(/\s/g, "-") + "-mi"
        );

        return secondReplacement;
      }
    }
    let { pageContext } = this.props;
    const city = pageContext.city;
    let pageData = this.props.data.contentfulServiceAreaContent;
    let citiesList = this.props.data.allContentfulServiceArea.edges;
    let content = parseContent(pageData.content.content);
    let zipCodes = pageContext.zipCodes;

    //replace city in keywords array
    if (pageData.metaKeywordsList) {
      pageData.metaKeywordsList.forEach(function (keyword, index) {
        pageData.metaKeywordsList[index] = parseContent(keyword);
      });
    }

    const TopBar = () => {
      //pageData has the data
      const topBar = pageData.topbar || [];
      return topBar.map(({ id, title, cssClasses, content }) => (
        <section key={id} className={cssClasses} dangerouslySetInnerHTML={{ __html: content.content }} />
      ));
    };
    const { testimonials: testimonial_video_posts } = pageData.testimonialSection || { testimonials: [] };

    const SidebarColumn = () => {
      const sideBarCards = pageData.sidebar.map((sidebar, index) => {
        if (sidebar.__typename == "ContentfulSidebar") {
          return <Card key={index} sidebar={sidebar} />;
        } else if (sidebar.__typename == "ContentfulSidebarCollection") {
          const innerCards = sidebar.sidebars.map((sidebar, index) => {
            return <Card key={"inner" + index} sidebar={sidebar} />;
          });
          return innerCards;
        } else return null;
      });

      return sideBarCards;
    };
    const schemaSameAs = getSchemaSameAs(this.props.data.site.siteMetadata.social);
    // Contentful city names carry stray leading/trailing whitespace, so always
    // use the trimmed value in URLs and copy.
    const cityName = String(city).trim();
    const cityKey = cityName.toLowerCase();
    // Per-city copy overrides. The shared Contentful entry backing these pages
    // renders on ~365 cities, so city-specific copy has to come from code.
    const cityContent = cityPageContent.forCity(city);
    // Repeated estimate/call pair, for cities whose design calls for it.
    const ctaPair = cityContent.heroTitle ? (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <CityCtaPair city={city} />
      </div>
    ) : null;
    const isFeaturedCity = cityKey === "jackson" || cityKey === "wyoming";
    // Phone for the office that serves this city. Jackson and Wyoming have
    // their own lines; every other city answers on the main Battle Creek number.
    const cityOffice = siteConfig.officeForCity(city);
    const cityPhone = siteConfig.phoneE164(siteConfig.phoneForCity(city));
    // Cities we have an office in get their own LocalBusiness node. Without a
    // distinct @id, one sitewide entity would assert three different telephone
    // numbers across these pages, which Google reads as conflicting NAP data.
    const businessId = cityOffice
      ? `https://roachhomeimprovement.com/#office-${cityOffice.city
          .toLowerCase()
          .replace(/\s+/g, "-")}`
      : "https://roachhomeimprovement.com#HomeAndConstructionBusiness";
    const officeAddressJson = cityOffice
      ? `
              "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "${cityOffice.address}",
                  "addressLocality": "${cityOffice.city}",
                  "addressRegion": "${cityOffice.state}",
                  "postalCode": "${cityOffice.zip}",
                  "addressCountry": "US"
              },`
      : "";
    return (
      <>
        <Layout pageProps={this.props} footerLogoShowcase={pageData.footerLogoShowcase} customSchema>
          <SEO
            title={parseContent(pageData.seoTitle)}
            description={parseContent(pageData.metaDescription)}
            keywords={pageData.metaKeywordsList ? pageData.metaKeywordsList : []}
          />
          <ServiceHero
            pageData={pageData}
            serviceTitle={cityContent.heroTitle || parseContent(pageData.serviceTitle)}
            heroImage={pageData.heroImage}
            excerpt={cityContent.heroExcerpt || parseContent(pageData.excerpt)}
            pageProps={this.props}
            badges={pageData.headerFeaturedBadges}
            specialOffer={parseContent(pageData.specialOffer)}
            offerDisclaimer={parseContent(pageData.offerDisclaimer)}
            ctaSlot={cityContent.heroTitle ? <CityCtaPair city={city} className="mt-6" /> : null}
          />
          {isFeaturedCity ? (
            <>
              <CityTrustStrip city={city} />
              {/* The design runs TrustedChoice before the reviews strip; cities
                  without their own copy keep the original order. */}
              {cityContent.heroTitle ? (
                <>
                  <CityTrustedChoice city={city} />
                  <CityHappyCustomers />
                </>
              ) : (
                <>
                  <CityHappyCustomers />
                  <CityTrustedChoice city={city} />
                </>
              )}
            </>
          ) : null}
          {pageData.socialReviewsFullWidth && pageData.socialReviewsFullWidth.slug ? (
            <SocialReviewsFullwidth modalLinkTo={`/reviews/${pageData.socialReviewsFullWidth.slug}/`} />
          ) : null}

          {pageData.photoGalleryRef && pageData.photoGalleryRef.photos ? (
            <PhotoGalleryComponent
              gallery={pageData.photoGalleryRef}
              titleOverride={cityContent.galleryHeading}
            />
          ) : null}

          {<TopBar />}

          {/* <TestimonialSection testimonial_video_posts={testimonial_video_posts} /> */}
          {/* bg-brand-600 text-white */}
          <div>
            <div className="flex flex-wrap  px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-8 md:py-12">
              <div className={`${pageData.sidebar ? "md:w-2/3 md:pr-4" : "w-full"} prose md:prose-lg`}>
                {/* Cities with their own copy render it from code; everyone else
                    keeps the shared Contentful body. */}
                {cityContent.bodyHeading ? (
                  <CityBodyContent city={city} />
                ) : (
                  content && <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
                {/* {zipCodes ? (
                  <h3 className="servicedzip">
                    Serviced ZIP Codes:{" "}
                    {intersperse(
                      zipCodes.map((zipCode, i) => zipCode),
                      ", "
                    )}
                    {zipCodes.map((zipCode) => (
                      <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                          __html: `
                            {
                              "@context": "https://www.schema.org",
                              "@type": "PostalAddress",
                              "addressLocality": "${city}",
                              "addressRegion": "MI",
                              "postalCode": "${zipCode}"
                            }
                           `,
                        }}
                      />
                    ))}
                  </h3>
                ) : null} */}

              </div>

              {pageData.sidebar ? (
                <div className="w-full md:w-1/3 md:pl-4 space-y-4 md:space-y-6">
                  {/* <Card /> */}
                  {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49843.94525730492!2d-121.17892723112209!3d38.66620084666653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ae11b89d97a7f%3A0xd44e4c2e31e1ce2a!2sFolsom%2C%20CA!5e0!3m2!1sen!2sus!4v1625607326120!5m2!1sen!2sus" width="1200" height="500" style="border:0; max-width:100%; max-height:500px;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> */}
                  <div className="aspect-ratio-box mb-4 rounded-lg shadow-md">
                    {/* Cities we have an office in show a map pinned to that office
                        (siteConfig.offices[].mapEmbedSrc); everyone else gets a
                        generic map centred on the city. */}
                    <iframe
                      className="aspect-ratio-box-inside projects-project"
                      title={
                        cityOffice
                          ? `Map of the Roach Home Improvement office in ${cityOffice.city}, ${cityOffice.state}`
                          : `Map of ${cityName}, MI`
                      }
                      src={
                        cityOffice && cityOffice.mapEmbedSrc
                          ? cityOffice.mapEmbedSrc
                          : `https://www.google.com/maps/embed/v1/place?key=AIzaSyCwXnoLHPbHNOjKkwCoFY8u4RHtqDGp8dM&q=${encodeURIComponent(
                              `${cityName}, MI`
                            )}`
                      }
                      width="100%"
                      frameBorder={0}
                      height="400"
                      loading="lazy"
                    />
                  </div>
                  <SidebarColumn />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          {!isFeaturedCity ? (
            <div className="rounded-2xl overflow-hidden max-w-7xl mx-auto relative px-8 py-20">
              <RoofingCalculator />
            </div>
          ) : null}
          {!isFeaturedCity ? <WhyRoachStandsOut city={city} /> : null}
          <RoofingServicesGrid city={city} />

          {/* Emergency section. Wyoming's is new code; Jackson already had one,
              and its copy already matches the design. */}
          <CityEmergencyRepair city={city} />
          {cityKey === "jackson" ? <JacksonEmergencyAndCosts city={city} section="emergency" /> : null}

          {ctaPair}

          {/* The two frames order the middle differently: Wyoming runs costs
              before "Get A New Roof In 3 Steps" and permits after; Jackson is
              the reverse, with the calculator and costs trailing. */}
          {cityKey === "wyoming" ? <WyomingCostsAndPermits city={city} section="costs" /> : null}
          {cityKey === "jackson" ? <JacksonEmergencyAndCosts city={city} section="permits" /> : null}

          <GetANewRoofSteps city={city} />

          {cityKey === "wyoming" ? <WyomingCostsAndPermits city={city} section="permits" /> : null}
          {cityKey === "jackson" ? (
            <>
              <JacksonEmergencyAndCosts city={city} section="calculator" />
              <JacksonEmergencyAndCosts city={city} section="costs" />
            </>
          ) : null}

          {/* No estimate/call pair here: both featured cities close this stretch
              with a CTA of their own (Wyoming's roof calculator "Get Pricing",
              Jackson's "Schedule a Free Consultation"), so a second one stacked
              underneath just reads as a duplicate. */}
          {isFeaturedCity ? (
            <>
              <CityNeighborhoods city={city} cities={citiesList} serviceSlug={pageData.slug} />
              <CityContactCard city={city} />
            </>
          ) : null}
          {!isFeaturedCity ? (
            <section className="py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-2xl md:text-3xl font-display font-extrabold text-neutral-900 mb-8">
                  Areas Served
                </h2>
                <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4 list-none p-0 m-0">
                  {citiesList.map((item, i) => (
                    <li key={i} className="flex items-start">
                      <CheckCircle
                        fontWeight={900}
                        strokeWidth={3}
                        size={18}
                        className="text-brand-500 mt-1 mr-2 flex-shrink-0"
                      />
                      <Link
                        style={{ textDecoration: "none" }}
                        className="text-neutral-800 underline-none"
                        title={`${parseContent(pageData.serviceTitle, item.node.location)}`}
                        to={`/${pageData.slug}-${item.node.slug}/`}
                      >
                        {parseContent(pageData.serviceName)} {item.node.location}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          ) : null}
          <FAQ classnames={'-mb-12'} city={city}/>
          <CTA
            title={"Start Your " + parseContent(pageData.serviceTitle) + " Project Today!"}
            customTitle={parseContent(pageData.footerCallToActionHeading)}
            customDesc={parseContent(pageData.footerCallToActionDesc)}
            bgimage={pageData.footerCallToActionImg}
            serviceHeroImage={pageData.heroImage}
            btn={"Get Started!"}
            props={this.props}
          />
        </Layout>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
            {
              "@id": "${businessId}",
              "@context": "https://www.schema.org",
              "@type": "HomeAndConstructionBusiness",
              "name": "Roach Home Improvement",
              "url": "https://roachhomeimprovement.com/",
              "logo": "https://images.ctfassets.net/seqn6hyrh7p7/47ugz3TDJq3S0Vlkz6QjRt/04a537cf23f52f952ef3dfdc0e144663/roachhomeimprovement-thumb.jpg",
              "image": "https://images.ctfassets.net/seqn6hyrh7p7/47ugz3TDJq3S0Vlkz6QjRt/04a537cf23f52f952ef3dfdc0e144663/roachhomeimprovement-thumb.jpg",
              "description": "Roach Home Improvement is a ${city} ${pageData.serviceTitle
              .replace(/{{city}}/g, "")
              .replace(" in ", "")
              .replace(", MI", "")} specializing in whole house remodeling and building custom homes near you.",
              "openingHours": "Mo, Tu, We, Th, Fr 08:00-18:00",
              "telephone": "${cityPhone}",
              "priceRange":"$$",${officeAddressJson}
              "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "sales",
                  "telephone": "${cityPhone}"
              }
          }`,
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
          {
            "@context": "http://schema.org/",
            "@type": "service",
            "servicetype": "${this.props.pageContext.serviceTitle}",
            "provider": {
                "@type": "organization",
                "name": "${this.props.data.site.siteMetadata.title}",
                "url": "${this.props.data.site.siteMetadata.siteUrl + this.props.location.pathname}",
                "logo": "https://images.ctfassets.net/seqn6hyrh7p7/47ugz3TDJq3S0Vlkz6QjRt/04a537cf23f52f952ef3dfdc0e144663/roachhomeimprovement-thumb.jpg",
                "image": "https://images.ctfassets.net/seqn6hyrh7p7/47ugz3TDJq3S0Vlkz6QjRt/04a537cf23f52f952ef3dfdc0e144663/roachhomeimprovement-thumb.jpg",
                "address": {
                    "@type": "postaladdress",
                    "addresslocality": "${city}",
                    "addressRegion": "MI",
                    "postalcode": "${this.props.pageContext.zipCode}"
                },
                "contactpoint": {
                    "@type": "contactpoint",
                    "contacttype": "customer support",
                    "telephone": "${cityPhone}",
                    "email": "${this.props.data.site.siteMetadata.companyInfo.email}"
                },
                "sameas": [${schemaSameAs.map((link) => `"${link}"`)}]
            },
            "areaserved": [{
                "@type": "city",
                "name": "${city}",
                "@id": "https://en.wikipedia.org/wiki/${city.replace(/\s/g, "_")},_Michigan"
            }],
            "hasoffercatalog": {
                "@type": "offercatalog",
                "name": "${this.props.pageContext.serviceTitle}",
                "itemlistelement": [{
                    "@type": "offercatalog",
                    "name": "${this.props.pageContext.serviceTitle.toLowerCase()} services",
                  
                }]
            }
        }
      `,
          }}
        />
      </>
    );
  }
}

export default ServiceCityTemplate;

export const pageQuery = graphql`
  query serviceCityQuery($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
        companyInfo {
          phone
          email
        }
        social {
          guildquality
          facebook
          yelp
          instagram
          google
          houzz
        }
      }
    }
    contentfulServiceAreaContent(slug: { eq: $slug }) {
      id
      serviceTitle
      serviceName
      seoTitle
      metaDescription
      slug
      excerpt
      specialOffer
      offerDisclaimer
      metaKeywordsList

      socialReviewsFullWidth {
        slug
      }
      testimonialSection {
        testimonials {
          id
          title

          video {
            id
            title
            file {
              url
              contentType
            }
          }
          thumbnail {
            gatsbyImageData(width: 600, quality: 90, placeholder: NONE)
          }
        }
      }
      photoGalleryRef {
        id
        title
        description {
          description
        }
        photos {
          id
          title
          gatsbyImageData(width: 150, quality: 70, aspectRatio: 1.26153846154, placeholder: NONE)
          fullSize: gatsbyImageData(width: 1874, quality: 70, placeholder: NONE)
        }
      }
      headerFeaturedBadges {
        title
        gatsbyImageData(width: 300, placeholder: NONE)
      }
      heroImage {
        gatsbyImageData(width: 1200, quality: 70, placeholder: BLURRED)
      }
      content {
        content
      }
      footerLogoShowcase
      footerCallToActionHeading
      footerCallToActionDesc
      footerCallToActionImg {
        gatsbyImageData(width: 1800, placeholder: NONE)
      }
      topbar {
        id
        title
        content {
          id
          content
        }
        cssClasses
      }
      sidebar {
        __typename
        ... on ContentfulSidebar {
          id
          title
          content {
            id
            content
          }
          testimonialCategory {
            id
            name
          }
          cssClasses
        }
        ... on ContentfulSidebarCollection {
          sidebars {
            id
            title
            content {
              id
              content
            }
            testimonialCategory {
              id
              name
            }
            cssClasses
          }
        }
      }
      schemaItemOffered
    }
    allContentfulServiceArea(sort: { fields: location }) {
      edges {
        node {
          location
          slug
          marketSegment
          zipCodes
        }
      }
    }
  }
`;
